import axios from "axios";
import * as API_LINKS from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_UNIT_LIST = 'FETCH_UNIT_LIST'
export const RECEIVE_UNIT_LIST = 'RECEIVE_UNIT_LIST'
export const FAILED_UNIT_LIST = 'FAILED_UNIT_LIST'

export function fetchUnit(){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_UNIT_LIST});
        axios({
            method: 'post',
            url: API_LINKS.UNIT_LIST_URL,
            headers: {
                Authorization: auth
            },
            // data: {
            //     id_work_order: _id_work_order
            // }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_UNIT_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_UNIT_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_UNIT_LIST
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_UNIT_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_UNIT_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_UNIT_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_UNIT_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}